import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, Award } from 'lucide-react';
const notThis = ['This is not a random collection of art activities copied from the internet.', 'This is not a theoretical book you have to rewrite before it works in a real class.', 'This is not a drawing-only program that leaves the rest of visual art uncovered.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-sand border-y border-warmgray" data-id="element-240" data-mp="z2fpkl2f7owf">
      <div className="max-w-4xl mx-auto text-center" data-id="element-241" data-mp="u2jk0he2rper">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-242" data-mp="u3urar6qbfam">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-terracotta/10 text-terracotta mb-5" data-id="element-243" data-mp="2ffwd0uudxid1">
            <Award size={26} aria-hidden="true" data-id="element-244" data-mp="2bunsrseloq7v" />
          </div>
          <p className="text-terracotta font-semibold tracking-[0.18em] uppercase text-xs mb-3" data-id="element-245" data-mp="2gujvzpfh4dmd">
            The Complete Professional System
          </p>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-charcoal" data-id="element-246" data-mp="2kx6prvvpg8m7">
            Art Teacher Ready
          </h2>
          <p className="text-base md:text-lg text-charcoal-soft mb-10" data-id="element-247" data-mp="1t57pwyfg0loa">
            7 Complete Volumes · 150 Ready-to-Teach Lessons · 5 Strategic
            Bonuses · Everything Ready to Use Today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-248" data-mp="224uqji0clnga">
          <motion.div initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-paper p-6 rounded-2xl border border-warmgray" data-id="element-249" data-mp="26wm8j45fukut">
            {notThis.map(item => <div key={item} className="flex items-start gap-3" data-id="element-250" data-mp="2qjasevhj8ks4">
                <X className="text-terracotta-dark shrink-0 mt-1" size={18} aria-hidden="true" data-id="element-251" data-mp="2qircfkbg06gq" />
                <p className="text-charcoal-muted text-sm" data-id="element-252" data-mp="1ytecc0btxuqh">{item}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-terracotta/10 p-6 rounded-2xl border border-terracotta/30" data-id="element-253" data-mp="1tv4hxrxxiy5x">
            <div className="flex items-start gap-3" data-id="element-254" data-mp="3mp2pjah7xs2t">
              <Check className="text-terracotta-deep shrink-0 mt-1" size={20} aria-hidden="true" data-id="element-255" data-mp="3msi5sgmmp75t" />
              <p className="text-charcoal font-medium text-base leading-relaxed" data-id="element-256" data-mp="3ct9czr3i1yl1">
                This is a complete professional library, so you walk into each
                class completely prepared, confident, and ready to teach an art
                experience your students can see, understand, and create from.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}